import { render } from "./AposTagListItem.vue?vue&type=template&id=2e60321d&scoped=true"
import script from "./AposTagListItem.vue?vue&type=script&lang=js"
export * from "./AposTagListItem.vue?vue&type=script&lang=js"

import "./AposTagListItem.vue?vue&type=style&index=0&id=2e60321d&lang=scss&scoped=true"

import exportComponent from "../../../../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e60321d"],['__file',"ui/ui/apos/components/AposTagListItem.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2e60321d"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2e60321d', __exports__)) {
    api.reload('2e60321d', __exports__)
  }
  
  module.hot.accept("./AposTagListItem.vue?vue&type=template&id=2e60321d&scoped=true", () => {
    api.rerender('2e60321d', render)
  })

}


export default __exports__